import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, intro, testid }) => {
  return (
    <section
      className="relative pt-20 pb-10 sm:pt-28 sm:pb-14 grain"
      data-testid={testid}
    >
      <div className="container-narrow relative">
        <motion.p
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="eyebrow"
        >
          {eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.05 }}
          className="font-serif mt-4 text-5xl sm:text-6xl lg:text-7xl text-[#2C2A28] leading-[1.02] tracking-tight max-w-4xl"
        >
          {title}
        </motion.h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.15 }}
            className="mt-6 max-w-2xl text-base sm:text-lg text-[#5C5852] leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
